import {Stack, Typography} from '@mui/material';
import React, {Fragment, memo} from 'react';

import {CardList} from 'presentation/components';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {StyledDistrictGrid} from './styles';
import {DistrictGridProps} from './types';

const {resultFound} = translations['pt-br'].commons;

export const DistrictGrid = memo(({list, handleSelectCard}: DistrictGridProps) => {
	const bookingData = useBookingStore(state => state.bookingData);

	const {SEARCH_PARAMS} = useQueryParams();
	const {query} = SEARCH_PARAMS;

	const FILTERED_DISTRICT_LIST = list.filter(districtItem =>
		districtItem.nmBairro.toLowerCase().includes(query.trim().toLowerCase()),
	);

	const showEmptyState = FILTERED_DISTRICT_LIST.length === 0;

	if (showEmptyState) {
		return null;
	}

	return (
		<Fragment>
			{query ? (
				<Typography variant="subtitle2" color="text.secondary">
					{resultFound}
				</Typography>
			) : null}
			<Stack gap={2}>
				<StyledDistrictGrid>
					{list.map((item, index) => (
						<CardList
							key={index}
							text={formatText(item.nmBairro)}
							selected={item.nmBairro === bookingData.districtName}
							handleClick={() => handleSelectCard(item.nmBairro)}
						/>
					))}
				</StyledDistrictGrid>
			</Stack>
		</Fragment>
	);
});
